import { YBadge, YIcon, YInput } from '@components/index';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import CoreMixin from '@nodes/mixins/Core';
import { get } from 'lodash/object';
import { digits } from '@nodes/helpers/number';
import {
    Component, Emit, Mixins,
} from 'vue-property-decorator';
import Props from './props';

@Component({
    components: {
        YIcon,
        YBadge,
        YInput,
    },
})

/**
 * @name WareDetail
 */
export default class WareDetail extends Mixins(CoreMixin, HybridMixin, Props) {
    digits = digits;
    selectedWare: {[key: string]: any} = null;
    count: number = 0;
    addedToFavorite: boolean = this.getValue('product').user_favoring;

    /**
     * Return router-link object
     *
     * @param {string} name
     * @param {object} cat
     * @returns {object}
     */
    routeTo(name: string, cat: {[key: string]: any }): object {
        const params: { [key: string]: any } = {};
        if (cat.url_encode) {
            params.url_encode = cat.url_encode;
        } else if (cat.id) {
            params.id = cat.id;
        }

        return {
            name,
            params,
        };
    }

    /**
     * Ware length
     *
     * @returns {boolean}
     */
    get wareLength(): boolean {
        return this.wares && this.wares.length > 0;
    }

    /**
     * Calculator Percent Discount
     *
     * @returns {number|string}
     */
    get discountPercent(): number | string {
        const val = ((this.selectedWare.original_price - this.selectedWare.sale_price) / this.selectedWare.original_price) * 100;
        // eslint-disable-next-line no-nested-ternary
        return val.toFixed(1)?.toString()?.split('.')[1] === '0' ? Math.round(val) : Math.round(val) > 1 ? Math.round(val) : val.toFixed(1);
    }

    /**
     * Check if product has discount
     *
     * @returns {boolean}
     */
    get hasDiscount(): boolean {
        return this.selectedWare.original_price !== this.selectedWare.sale_price;
    }

    /**
     * change selectedWare
     *
     * @param {object} ware
     */
    onSelectedWareChanged(ware: {[key: string]: any}): void {
        this.selectedWare = ware;
        const existInStore = this.$store.getters['cart/myCart']
            .findIndex((o) => (o.ware_id === ware.id) && (o.post_id === this.product.id));

        if (existInStore < 0) {
            this.count = 0;
        } else {
            this.count = get(this.$store.getters['cart/myCart'], `${existInStore}.count`, 0);
        }
    }

    /**
     * change Count
     *
     * @returns {object}
     */
    @Emit('updateCart')
    onCountChanged(): object {
        this.selectedWare.count = this.count;

        return {
            count          : this.selectedWare.count,
            post_id        : this.product.id,
            sale_price     : this.selectedWare.sale_price,
            ware_id        : this.selectedWare.id,
            single_price   : this.selectedWare.original_price,
            single_discount: this.selectedWare.discount,
            ware_title     : `${this.product.title} ـ ${this.selectedWare.title}`,
            post_image     : get(this.product, 'image'),
            post_tagging   : get(this.product, 'product_tagging_categories'),
        };
    }

    /**
     * Add Product to favorites
     *
     * @param {string} id
     * @returns {*}
     */
    addToFavorite(id: string) {
        if (!this.$store.getters['auth/isLoggedIn']) {
            return this.$toast.error(this.$t('wareDetail.login'));
        }
        this.$wait.start(`add-to-wishlist-${id}`);
        const params = {
            id,
            model : 'content-post',
            status: Number(!this.addedToFavorite),
        };
        return this.$services.Relation.favouritesChange(params).then(() => {
            this.addedToFavorite = !this.addedToFavorite;
            if (this.addedToFavorite) {
                this.$toast.success(this.$t('wareDetail.wishlist.add_msg'));
            } else {
                this.$toast.success(this.$t('wareDetail.wishlist.delete_msg'));
            }
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end(`add-to-wishlist-${id}`);
        });
    }

    /**
     * Increase number of product
     */
    increase() {
        this.count += 1;
        this.onCountChanged();
    }
    
    /**
     * Decrease Product to product
     */
    decrease() {
        if (this.count > 0) {
            this.count -= 1;
            this.onCountChanged();
        }
    }

    /**
     * @inheritdoc
     */
    created() {
        if (get(this, 'wares.0', null)) {
            this.onSelectedWareChanged(this.wares[0]);
        }
    }
}
